import React, { useState, useEffect, useRef } from "react";
import { getSupersetUrl } from "../../../Services/pipelineanalyticsService";
import ToastElement from "../../../Components/UiComponents/ToastElement";
import { client, get } from "../../../Services/customerServices";
import { embedSupersetDashboard } from "../../../Services/pipelineanalyticsService";
import { Dialog } from "primereact/dialog";
import { getModulePermissions } from "../../../Services/pricingPlanService";
import { getCustomer, getClientList } from "../../../Services/customerServices";
import _ from "lodash";
import ButtonElement from "../../../Components/UiComponents/ButtonElement";
import { generateStageReport, generateProjectReport, generatePptProjectReport } from "../../../Services/pipelineanalyticsService";
import icon from "../../../Assets/Img/mc_icon_white.png";
import Loader from "../../../Components/UiComponents/Loader";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../Components/Videos/PlaylistVideos";
import SingleSelectElement from "../../../Components/UiComponents/SingleSelectElement";

const DashBoard = () => {
    const [showReport, setShowReport] = useState(false);
    const [sectionPermissions, setSectionPermissions] = useState({});
    const [pricingPlan, setPricingPlan] = useState("");
    const [shortName, setShortName] = useState("");
    const [loading, setLoading] = useState(false);
    const [clientList, setClientList] = useState([]);
    const [isPPTGenerate, setIsPPTGenerate] = useState(false);
    const [selectedClient, setSelectedClient] = useState(null);
    const [showVideo, setShowVideo] = useState(false);
    const navigate = useNavigate()

    var enduser = localStorage.getItem("enduser")
    if (enduser) {
        var tmpData = JSON.parse(enduser);
        if (tmpData === null) {
            navigate("/login")
            localStorage.clear()
        }
    }

    const toastRef = useRef();

    useEffect(() => {
        getSupersetData()
        getCustomerDetails()
        getClientListDetails();
    }, [])

    useEffect(() => {
        if (pricingPlan) {
            getModulePermission();
        }
    }, [pricingPlan])

    const getCustomerDetails = async () => {
        var customerDataResponse = await getCustomer(tmpData.customer);
        setPricingPlan(customerDataResponse.data.pricing_plan);
        setShortName(customerDataResponse.data.customer_short);
    }

    const getClientListDetails = async () => {
        const res = await getClientList(tmpData.customer);
        if (res.data) {
            const clientList = res.data;
            setClientList(clientList.clients);
        }
    }

    const getSupersetData = async () => {
        setLoading(true)
        var supersetUrl = await getSupersetUrl()
        var customerData = await get(tmpData.customer)
        if (customerData.data) {
            var supersetUrl = supersetUrl.data;
            var supersetApiUrl = supersetUrl + '/api/v1/security';
            var dashboardId = customerData.data.dashboard_id;
            if (dashboardId) {
                var embed = await embedSupersetDashboard(supersetUrl, supersetApiUrl, dashboardId, tmpData.customer)
                if (embed != undefined && embed.data) {
                    // Adjust the size of the embedded iframe
                    const iframe = document.querySelector('#dashboard-iframe iframe');
                    if (iframe) {
                        iframe.style.width = '100%';
                        iframe.style.minHeight = '92vh';
                    }
                }
                setLoading(false)
            } else {
                if (toastRef.current != null) {
                    toastRef.current.showToast({
                        type: 'error',
                        message: "Dashboard is not mapped to the customer"
                    });
                }
                setLoading(false)
            }
        }
    }

    const getModulePermission = async () => {
        if (pricingPlan) {
            const res = await getModulePermissions(pricingPlan, "Dashboard");

            if (res.data) {
                const modulePermissions = res.data;

                if (modulePermissions.status && modulePermissions.sections) {
                    const sectionPermissions = {};
                    _.filter(modulePermissions.sections, (section) => {
                        sectionPermissions[section.section] = section.status;
                    });
                    setSectionPermissions(sectionPermissions);
                }
            }
        }
    };

    const handleReport = () => {
        setShowReport(true)
    }

    const closePopup = () => {
        setShowReport(false)
    }

    const downloadReport = () => {
        if (shortName === 'BAXALL' || shortName === 'ESGPrev') {
            var stageReport = generateStageReport(tmpData.customer)
        } else if (shortName === 'Valuem') {
            var projectReport = generateProjectReport(tmpData.customer)
        }
    }
    const downloadReport2 = () => {
        if (shortName === 'GRI') {
            var stageReport = generateStageReport(tmpData.customer)
        }
    }
    const downloadReport3 = () => {
        if (shortName === 'GRI') {
            var stageReport = generateProjectReport(tmpData.customer)
        }
    }

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const downloadPptReport = () => {
        if (shortName === 'Valuem') {
            generatePptProjectReport(tmpData.customer, selectedClient)
        }
    }

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="col-md-12 text-right">
                <ButtonElement className="upload-button mt-2 mb-2" type="button" icon="pi pi-video" onClick={handleButtonClick}></ButtonElement>
            </div>
            <div id="dashboard-iframe" />
            {
                (shortName === 'BAXALL' || shortName === 'Valuem' || shortName === 'GRI' || shortName === 'ESGPrev') &&
                <img
                    src={icon}
                    className="logo-icon-dashboard"
                    onClick={handleReport}
                />
            }
            <Dialog
                header={
                    (sectionPermissions['Gateway Report'] || sectionPermissions['Bid Report A']) ?
                        "Status Reports" : "Reports"
                }
                visible={showReport}
                position="right"
                onHide={() => closePopup()}
                draggable={false}
                resizable={false}
                className="table-dialog"
            >
                {(shortName === 'GRI')? (
                <div className="form-group row align-items-center mb-0 mt-0">
                    <div className="col-6 pl-0">
                                <label className="form-label text-left">Weekly Status Report</label> :
                    </div>
                    <div className='col-6 pr-0'>
                            <ButtonElement
                                icon="pi pi-download"
                                onClick={downloadReport2}
                                className="save-button"
                            />
                    </div>
                    <div className="col-6 pl-0">
                                <label className="form-label text-left">Project Data Report</label>  {" "}:
                    </div>
                    <div className='col-6 pr-0'>
                            <ButtonElement
                                icon="pi pi-download"
                                onClick={downloadReport3}
                                className="save-button"
                            />
                    </div>
                </div>) :
                (<div className="form-group row align-items-center mb-0 mt-0">
                    <div className="col-md-4 pl-0">
                        {
                            sectionPermissions['Weekly Status Report'] &&
                                (shortName === 'BAXALL') ?
                                <label className="form-label text-left">Weekly Status Report</label> :
                                <label className="form-label text-left">Project Data Report</label>
                        }
                    </div>
                    <div className='col pr-0'>
                        {
                            sectionPermissions['Weekly Status Report'] &&
                            <ButtonElement
                                icon="pi pi-download"
                                onClick={downloadReport}
                                className="save-button"
                            />
                        }
                    </div>
                </div>)}
                {(shortName === 'Valuem') && (
                    <div className="form-group row align-items-center mb-0 mt-0">
                    <div className="col-4 pl-0">
                        <label className="form-label text-left">
                            PowerPoint Report
                        </label>
                    </div>
                    <div className="col-5 pr-0 ml-3">
                        <SingleSelectElement
                            value={selectedClient}
                            optionLabel="label"
                            optionValue="value"
                            options={clientList}
                            placeholder="-- Please select --"
                            maxSelectedLabels={1}
                            onChangeValue={(e) => setSelectedClient(e.value)}
                            className="w-full"
                        />
                    </div>
                    <div className="col-1 pr-0">
                        <ButtonElement
                            disabled={selectedClient === null}
                            onClick={downloadPptReport}
                            className="save-button"
                        >
                            Generate
                        </ButtonElement>
                    </div>
                </div>
                    
                ) }
            </Dialog>

            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_MAIN_MODULES_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="dashboards" />
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default DashBoard